import { Grid, Typography } from '@mui/material';
import { BasicButton } from '@tassat/button';
import React from 'react';

import type { PendingClientValidationStatusModalProps } from '.';

const PendingClientValidationStatusModal = (props: PendingClientValidationStatusModalProps) => {
    const { data: { FirstName, LastName, firmName }, classes, hadleOnClick } = props;

    return (
        <Grid
            alignItems='center'
            className={classes.root}
            container
            direction='column'
        >
            <Grid
                alignItems='center'
                className={classes.mainTextContainer}
                container
                direction='column'
            >
                <Typography className={classes.midSizeLine}>You have successfully created new client user</Typography>
                <Typography className={classes.clientName}>{`${FirstName} ${LastName}`}</Typography>
                <Typography>to</Typography>
                <Typography className={classes.midSizeLine}>{firmName}</Typography>
                <Typography className={`${classes.boldText} ${classes.paddingText}`}>Your request is in process. Please check back later</Typography>
                <Typography className={classes.paddingText}>View complete details in your Firms, User Tab.</Typography>
            </Grid>
            <BasicButton
                className={classes.buttonStyle}
                onClick={hadleOnClick}
                text='DONE'
                type='whiteSlim'
            />
        </Grid>
    );
};

export default PendingClientValidationStatusModal;